(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boski-legal-trust"] && !Shopify.designMode) return;
  try {
    (() => {
    const templateId = 'bbLegalAssuranceTemplate';
    const targets = [
      { selector: '.product-form__buttons', position: 'afterend', context: 'product' },
      { selector: 'main .cart__ctas', position: 'beforebegin', context: 'cart' }
    ];
    const mountAssurance = () => {
      const template = document.getElementById(templateId);
      if (!template) return;
      targets.forEach((item) => {
        document.querySelectorAll(item.selector).forEach((target) => {
          if (target.dataset.bbLegalMounted === 'true') return;
          const fragment = template.content.cloneNode(true);
          const assurance = fragment.firstElementChild;
          assurance.dataset.bbContext = item.context;
          target.insertAdjacentElement(item.position, assurance);
          target.dataset.bbLegalMounted = 'true';
        });
      });
    };
    let scheduled = false;
    const scheduleMount = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        mountAssurance();
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountAssurance, { once: true });
    } else {
      mountAssurance();
    }
    new MutationObserver(scheduleMount).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
